/**
 * @deprecated in favor of `Variant` in [`@asn/amount-display`](https://designsystem.acc.aws.devolksbank.net/index.html?path=/docs/web-components-amount-display--docs). To be removed with the Angular 23 migration.
 */
export enum Variant {
    DEFAULT = 'default',
    POSITIVE_ACCENT = 'positive-accent',
    NEGATIVE_ACCENT = 'negative-accent',
    EXPLICIT = 'explicit'
}

export type DisplaySize = 'default' | 'medium' | 'large';
